"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _DarkBoxInputPassword = require("./DarkBoxInputPassword.style");

var _DarkBoxInput = _interopRequireDefault(require("../Input/DarkBoxInput"));

var _IconCloseEye = _interopRequireDefault(require("../Icons/IconCloseEye"));

function DarkBoxInputPassword(props) {
  var passwordWrapperClassName = props.passwordWrapperClassName,
      showPasswordDefault = props.showPasswordDefault,
      rest = (0, _objectWithoutProperties2.default)(props, ["passwordWrapperClassName", "showPasswordDefault"]);

  var _useState = (0, _react.useState)(showPasswordDefault),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showPassword = _useState2[0],
      setShowPassword = _useState2[1];

  var toggleShowPassword = function toggleShowPassword() {
    setShowPassword(function (prevShowPassword) {
      return !prevShowPassword;
    });
  };

  return _react.default.createElement("div", {
    className: (0, _classnames.default)(_DarkBoxInputPassword.boxInputPassword, passwordWrapperClassName)
  }, _react.default.createElement(_DarkBoxInput.default, (0, _extends2.default)({
    type: showPassword ? 'text' : 'password',
    placeholder: "Password"
  }, rest)), _react.default.createElement("span", {
    onClick: toggleShowPassword,
    className: "toggle-password",
    role: "presentation"
  }, showPassword ? _react.default.createElement(_IconCloseEye.default, null) : _react.default.createElement(_IconCloseEye.default, null)));
}

DarkBoxInputPassword.defaultProps = {
  passwordWrapperClassName: '',
  showPasswordDefault: false
};
var _default = DarkBoxInputPassword;
exports.default = _default;